import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from "@syncfusion/ej2-angular-richtexteditor";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";

@Component({
  selector: "app-faq-translation",
  templateUrl: "./faq-translation.component.html",
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
  standalone: false,
})
export class FaqTranslationComponent implements OnInit {
  @Input() data: string = "";
  @Input() question: string = "";
  @Input() placeholder: string = "";
  @Input() languageList: any = [];
  @Input() faqData;

  /*   {
    screenDetails: {};
    primaryLanguage: { id: ""; updatedAt: "" };
    supportedLanguage: { id: ""; updatedAt: "" };
  }; */
  @Input() languageId;
  @Output() save = new EventEmitter<string>();

  isEditing: boolean = false;

  public toolbarSettings: object = {
    items: ["Bold", "Italic", "Underline", "Formats", "Undo", "Redo"],
  };

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private crudService: CrudService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    if (!this.data && !this.question) {
      this.isEditing = true;
      this.data = "";
      this.question = "";
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  saveEdit() {
    var payload = {
      ...this.faqData,

      // ...this.faqData.primaryLanguage,
      question: this.question,
      answer: this.data,
      languageId: this.languageId,
    };

    if (
      this.faqData.supportedLanguage["id"] != undefined &&
      this.faqData.supportedLanguage["id"] != null &&
      this.faqData.supportedLanguage["id"].trim()
    ) {
      this.crudService.update(
        payload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.toastr.success(
              "FAQ has been created successfully.",
              "Success"
            );
            this.save.emit();
            this.isEditing = false;
          }
        },
        "currentFaqDetails/" + this.faqData.supportedLanguage["id"]
      );
    } else {
      this.crudService.post(
        payload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.toastr.success(
              "FAQ has been created successfully.",
              "Success"
            );
            this.save.emit();
            this.isEditing = false;
          }
        },
        "currentFaqDetails"
      );
    }
  }
}
